<template>
    <div class="tab-cc w-full s-sidebarwidget s-sidebarwidget__yellow s-anchors s-anchors__grayscale">
      <div class="d-block contenu-sidebarwidget p-0 m-0">
        <div class="s-sidebarwidget--header flex s-sidebarwidget__small-bold-text fc-light d:fc-black-900 bb bbw1">
          <svg xmlns="http://www.w3.org/2000/svg" class="fill-current mr-2" width="20" height="20" viewBox="0 0 24 24">
            <path d="M12 5.177l8.631 15.823h-17.262l8.631-15.823zm0-4.177l-12 22h24l-12-22zm-1 9h2v6h-2v-6zm1 9.75c-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25 1.25.56 1.25 1.25-.561 1.25-1.25 1.25z"/>
          </svg>
          Changement dans l'ordre des cas
        </div>
        <div class="s-sidebarwidget--item">
          
          <!-- Transitions principales -->
          <table class="w-full">
            <tbody>
              <tr>
                <td><b>{{ $t('outofstock') }}</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('to prepare') }}</b></td>
              </tr>
              <tr>
                <td><b>{{ $t('to prepare') }}</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('outofstock') }}</b></td>
              </tr>
            </tbody>
          </table>
  
          <hr class="hr-grey">
  
          <!-- Transitions de préparation -->
          <table class="w-full">
            <tbody>
              <tr>
                <td><b>({{ $t('to prepare') }}, {{ $t('cancelled') }}, {{ $t('refused') }}, {{ $t('shipped') }}, {{ $t('reprogrammer') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('prepared') }}</b></td>
              </tr>
              <tr>
                <td><b>({{ $t('shipped') }}, {{ $t('region in progress') }}, {{ $t('prepared') }}, {{ $t('cancelled') }}, {{ $t('refused') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('reprogrammer') }}</b></td>
              </tr>
              <tr>
                <td><b>({{ $t('prepared') }}, {{ $t('reprogrammer') }}, {{ $t('region in progress') }}, {{ $t('cancelled') }}, {{ $t('refused') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('shipped') }}</b></td>
              </tr>
              <tr>
                <td><b>({{ $t('shipped') }}, {{ $t('reprogrammer') }}, {{ $t('refused') }}, {{ $t('cancelled') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('region in progress') }}</b></td>
              </tr>
              <tr>
                <td><b>({{ $t('prepared') }}, {{ $t('reprogrammer') }}, {{ $t('region in progress') }}, {{ $t('shipped') }}, {{ $t('to prepare') }}, {{ $t('cancelled') }}, {{ $t('refused') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('return callcenter') }}</b></td>
              </tr>
            </tbody>
          </table>
  
          <hr class="hr-grey">
  
          <!-- Transitions finales -->
          <table class="w-full">
            <tbody>
              <tr>
                <td><b>{{ $t('shipped') }}</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('delivered') }}</b></td>
              </tr>
              <tr>
                <td><b>{{ $t('delivered') }}</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('paid') }}</b></td>
              </tr>
            </tbody>
          </table>
  
          <hr class="hr-grey">
  
          <!-- Transitions d'annulation et retour -->
          <table class="w-full">
            <tbody>
              <tr>
                <td><b>({{ $t('prepared') }}, {{ $t('shipped') }}, {{ $t('reprogrammer') }}, {{ $t('region in progress') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('cancelled') }}</b></td>
              </tr>
              <tr>
                <td><b>({{ $t('prepared') }}, {{ $t('shipped') }}, {{ $t('reprogrammer') }}, {{ $t('region in progress') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('refused') }}</b></td>
              </tr>
              <tr>
                <td><b>({{ $t('refused') }}, {{ $t('cancelled') }}, {{ $t('paid') }})</b></td>
                <td>
                  <span>
                    <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/>
                    </svg>
                  </span>
                </td>
                <td class="text-right"><b>{{ $t('return') }}</b></td>
              </tr>
            </tbody>
          </table>
        </div>    
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StatusTransitions',
    data() {
      return {
        allowedTransitions: {
          "to prepare": ["outofstock"],
          "outofstock": ["to prepare"],
          "prepared": ["to prepare", 'cancelled', 'refused', 'shipped', 'reprogrammer'],
          "reprogrammer": ["shipped", 'region in progress', 'prepared', 'cancelled', 'refused'],
          "shipped": ["prepared", "reprogrammer", 'region in progress', 'cancelled', 'refused'],
          'region in progress': ["shipped", 'reprogrammer', "refused", "cancelled"],
          'return callcenter': ["prepared", "reprogrammer", 'region in progress', 'shipped', 'to prepare', 'cancelled', 'refused'],
          "delivered": ["shipped"],
          "paid": ["delivered"],
          "cancelled": ["prepared", "shipped", "reprogrammer", 'region in progress'],
          "refused": ["prepared", "shipped", "reprogrammer", 'region in progress'],
          "return": ["refused", "cancelled", "paid"],
        }
      };
    },
    methods: {
      getTransitionsForStatus(status) {
        return this.allowedTransitions[status] || [];
      }
    }
  };
  </script>
  
  <style scoped>
  .s-sidebarwidget {
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    background-color: #fff;
  }

  .contenu-sidebarwidget{
    background-color: #fbf3d5;
  }
  
  .s-sidebarwidget__yellow {
    border-left: 4px solid #f4a261;
  }
  
  .s-sidebarwidget--header {
    padding: 12px 16px;
    border-bottom: 1px solid #e6e6e6;
    font-weight: 600;
    font-size: 14px;
  }
  
  .s-sidebarwidget--item {
    padding: 16px;
  }
  
  .hr-grey {
    border: none;
    border-top: 1px solid #e6e6e6;
    margin: 16px 0;
  }
  
  table {
    font-size: 14px;
  }
  
  table td {
    padding: 8px 4px;
    vertical-align: middle;
  }
  
  .fill-current {
    color: #666;
  }


  </style>